export interface IProduct {
  _id?: string
  code: string
  name: string
  description: string
  image: string
  images: string[]
  price: number
  cost: number
  quantity: number
  merchant: string
  merchantPrefix: string
  category: string
  categoryName: string
  actions?: IAction[] | any
  isCollection: boolean
  collections?: ICollections[]
  commission: number
  isAvailable: boolean
  actor: string
  objectId: string
  attributes: IProductAttribute[]
  productCategory: IProductCategory
  createdAt: string | Date
  platform?: string[]
  updatedAt: string | Date
  options: IProductOption[]
  meta?: Record<string, any> | IProductMeta
  referrer?: {
    [key: string]: string
  }
  platformLinks?: IPlatformLink[]
  channels?: {
    name: string
    objectId: string
    image: string
    code: string
  }[]
}

// การผูกสินค้าในระบบเข้ากับ SKU ฝั่ง marketplace — 1 สินค้าผูกได้หลายรายการ
// (หลาย variant / หลายร้าน / หลาย platform) ต่างจาก referrer ที่เก็บได้ค่าเดียวต่อ platform
// productName/shopName เก็บไว้แสดงผลเท่านั้น ไม่ใช้ match — snapshot ณ วันผูก
// (id ล้วนอ่านไม่รู้เรื่อง และ seller_sku บางร้านก็ว่างเปล่า)
export interface IPlatformLink {
  platform: string
  shopId?: string
  shopName?: string
  platformId?: string
  productName?: string
  skuId?: string
  sku?: string
  linkedBy?: string
  linkedAt?: string | Date
}

// SKU ฝั่ง marketplace ที่ร้านนี้ผูกไปแล้ว + สินค้าที่ถือมันอยู่
// (GET /product/platform-links/used) — ใช้ปิดตัวเลือกกันผูกซ้ำข้ามสินค้า
export interface IUsedPlatformLink {
  platform: string
  skuId?: string
  sku?: string
  platformId?: string
  shopId?: string
  productObjectId: string
  productName: string
  productCode: string
}

export interface IProductMeta {
  size: string
  weight: string
  color: string
}

export interface IProductTransaction {
  objectId?: string
  product: IProduct
  quantity: number
  quantityBefore: number
  quantityAfter: number
  remark?: string
  orderCode?: string
  description?: string
  actor: string
  date?: Date
  createdAt?: Date
  updatedAt?: Date
}

export interface IProductOption {
  name?: string
  image?: string
  size?: string
  color?: string
  weight?: string
}

export interface IProductAttribute {
  name?: string
  value?: string
}

export interface IProductCategory {
  objectId: string
  code: string
  name: string
  description: string
  isAvailable: boolean
}

export interface ICollections {
  objectId?: string
  image?: string
  code?: string
  name?: string
  quantity?: number
  price?: number | string
  cost?: number | string
}

export interface IProductTable {
  code: string
  name: string
  images: string[]
  price: number
  cost: number
  totalPrice: number
  totalCost: number
  amount: number
}

export interface IAction {
  actor: string
  action: EAction
  quantity: number
  orderCode?: string
  order?: string
  description?: string
  date: string | Date
}

export enum EAction {
  ADD_QUANTITY = 'ADD_QUANTITY',
  REDUCE_QUANTITY = 'REDUCE_QUANTITY',
}

export interface ProductSummary {
  totalCost: number
  totalQuantity: number
}
